module.exports = __webpack_public_path__ + "static/img/bg_login.3c5dc18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_login.png
// module id = BgUH
// module chunks = 41